import { cx } from '../cx.js';
import { TextField } from './TextField.js';

export interface DateRangeFieldProps {
  /** Valori `YYYY-MM-DD` (input nativo `date`). */
  da: string;
  a: string;
  onChange: (valori: { da: string; a: string }) => void;
  labelDa?: string;
  labelA?: string;
  error?: string;
  className?: string;
}

/** Intervallo di date con due campi nativi: funziona ovunque, anche da tastiera. */
export function DateRangeField({ da, a, onChange, labelDa = 'Dal giorno', labelA = 'Al giorno', error, className }: DateRangeFieldProps) {
  return (
    <div className={cx('grid grid-cols-1 sm:grid-cols-2 gap-4', className)}>
      <TextField label={labelDa} type="date" value={da} max={a || undefined} onChange={(e) => onChange({ da: e.target.value, a })} />
      <TextField label={labelA} type="date" value={a} min={da || undefined} onChange={(e) => onChange({ da, a: e.target.value })} error={error} />
    </div>
  );
}
